// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .platform-container {
  padding-top: 40px;
  margin-bottom: 3rem;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  :host ::ng-deep .platform-container {
    padding-top: 0;
    margin-bottom: 6rem;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) and (max-width: 767px) {
  :host ::ng-deep .platform-container {
    padding-top: 0;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  :host ::ng-deep .platform-container {
    padding-top: 0;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  :host ::ng-deep .platform-container {
    padding-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/platform/platform.component.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;EACA,mBAAA;AAAR;;AAIA,iDAAA;AACA;EAEQ;IACI,cAAA;IACA,mBAAA;EAFV;AACF;AAMA,oEAAA;AACA;EAEQ;IACI,cAAA;EALV;AACF;AASA,qDAAA;AACA;EAEQ;IACI,cAAA;EARV;AACF;AAYA,mDAAA;AAGA,oEAAA;AACA;EAEQ;IACI,cAAA;EAbV;AACF","sourcesContent":["::ng-deep {\n    .platform-container {\n        padding-top: 40px;\n        margin-bottom: 3rem;\n    }\n}\n\n/* Extra small devices (phones, 600px and down) */\n@media only screen and (max-width: 600px) {\n    :host ::ng-deep {\n        .platform-container {\n            padding-top: 0;\n            margin-bottom: 6rem;\n        }\n    }\n}\n\n/* Small devices (portrait tablets and large phones, 600px and up) */\n@media only screen and (min-width: 600px) and (max-width: 767px) {\n    :host ::ng-deep {\n        .platform-container {\n            padding-top: 0;\n        }\n    }\n}\n\n/* Medium devices (landscape tablets, 768px and up) */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n    :host ::ng-deep {\n        .platform-container {\n            padding-top: 0;\n        }\n    }\n}\n\n/* Large devices (laptops/desktops, 992px and up) */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {}\n\n/* Extra large devices (large laptops and desktops, 1200px and up) */\n@media only screen and (min-width: 1200px) {\n    :host ::ng-deep {\n        .platform-container {\n            padding-top: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
